import { useRef, useEffect, useCallback } from "react";
import { IoEllipsisVertical } from "react-icons/io5";
import { BsPencil } from "react-icons/bs";
import { FaRedoAlt } from "react-icons/fa";
import styles from "./DotsPopover.module.css";
import { useTour } from "@reactour/tour";

export default function DotsPopover({
  isVisible,
  togglePopover,
  onRestore,
  onEdit,
}) {
  const popoverRef = useRef(null);
  const buttonRef = useRef(null);
  const { setCurrentStep, currentStep } = useTour();
  const handleClickOutside = useCallback(
    event => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        togglePopover(false);
      }
    },
    [togglePopover]
  );

  useEffect(() => {
    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, handleClickOutside]);

  const handleEdit = () => {
    togglePopover(false);
    onEdit();
    console.log("Редагувати контакт");
  };

  const handleRestore = () => {
    togglePopover(false);
    onRestore();
  };
  return (
    <div className={styles.container}>
      <button
        data-tour-carslist="step-3.6"
        ref={buttonRef}
        className={styles.button}
        onClick={() => {
          togglePopover(!isVisible);
          setCurrentStep(currentStep + 1);
        }}
      >
        <IoEllipsisVertical className={styles.icon} color="var(--white)" />
      </button>

      {isVisible && (
        <div
          ref={popoverRef}
          className={styles.popover}
          data-tour-carslist="step-3.7"
        >
          <ul className={styles.listBtn}>
            <li className={styles.option}>
              <button className={styles.editBtn} onClick={handleEdit}>
                <BsPencil className={styles.iconSecond} />
                Редагувати
              </button>
            </li>
            <li className={styles.option}>
              <button className={styles.editBtn} onClick={handleRestore}>
                <FaRedoAlt className={styles.iconSecond} />
                Відновити
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
